module.exports = __webpack_public_path__ + "static/media/22904910_1638431882898663_6347954105983718813_o-thumb.ca73b1f6.jpg";